import { render, staticRenderFns } from "./MandatoryPackageDetail.vue?vue&type=template&id=dc85e422&"
import script from "./MandatoryPackageDetail.vue?vue&type=script&lang=js&"
export * from "./MandatoryPackageDetail.vue?vue&type=script&lang=js&"
import style0 from "./MandatoryPackageDetail.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports